import authConfigInstance from './authServise';

export const getUserToken = async (forceRefresh=false): Promise<string | undefined> => {
  const accessToken = await authConfigInstance
    .getToken(forceRefresh)
    .then(accessTokenResponse => accessTokenResponse.accessToken)
    .catch(error => {
      console.error('~~~~~ token ERROR ~~~~ %o', error);
    });

  return accessToken;
};
